/**
 * WEB-894: scripts injected by the Google iOS app's in-app browser throw
 * `Maximum call stack size exceeded` from anonymous frames (no filename) —
 * same family as the ignored `gmo` errors:
 * https://issuetracker.google.com/issues/396043331
 * `ignoreErrors` would also hide genuine overflows (same message) and
 * `denyUrls` can't match frames without URLs, hence this beforeSend guard.
 */

interface StackFrame {
  filename?: string
}

interface SentryEventLike {
  exception?: {
    values?: Array<{
      value?: string
      stacktrace?: { frames?: StackFrame[] }
    }>
  }
}

const isAnonymousFrame = (frame: StackFrame): boolean => {
  const filename = frame.filename
  return !filename || filename === 'undefined' || filename === '<anonymous>' || filename === '[native code]'
}

/**
 * True for stack-overflow events with no frame from our own bundle (our
 * frames always carry a filename). Checks every exception in the chain.
 */
export function isThirdPartyCallStackOverflow(event: SentryEventLike): boolean {
  const exceptions = event.exception?.values ?? []
  return exceptions.some((exception) => {
    if (!exception.value?.includes('Maximum call stack size exceeded')) return false
    const frames = exception.stacktrace?.frames ?? []
    return frames.every(isAnonymousFrame)
  })
}
